export const generalAccess = ['user', 'finance', 'report', 'supervisor']
export const superAccess = ['supervisor', 'superAdmin', 'finance']
export const adminFinanceAccess = ['superAdmin', 'finance']
export const financeAccess = ['finance']
export const archivedDataAccess = ['dataAdmin']
